import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './pwa-supports'

ReactDOM.render(<App />, document.getElementById('root'))
window.FRONT_BUILD_VERSION = "1.560-master"; console.log("FRONT_BUILD_VERSION: 1.560-master"); // eslint-disable-line
